import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { RootState } from '../../../../store'
import {
  selectAVMEquity,
  selectOutstandingPrincipal,
} from '../../../../store/selectors/home/avm'
import { selectCurrentLoans } from '../../../../store/selectors/home/loans'
import { selectHomeValue } from '../../../../store/selectors/home/metadata'
import { selectCurrentAVMMap } from '../../../../store/selectors/homePreview'
import { CurrentAVMMap } from '../../../../types/avm'
import { NetWorthSection } from './NetWorthSection'
import * as Sentry from '@sentry/browser'

export const NetWorth = () => {
  const homeValue = useSelector(selectHomeValue)
  const hasLoans = Boolean(useSelector(selectCurrentLoans).length)
  const outstandingPrincipal = useSelector(selectOutstandingPrincipal)
  const estimatedValue = useSelector(selectAVMEquity)

  return (
    <NetWorthSection
      withCurrentHomeData
      homeValue={homeValue}
      hasLoans={hasLoans}
      outstandingPrincipal={outstandingPrincipal}
      estimatedValue={estimatedValue}
    />
  )
}

export const NetWorthPreview = () => {
  const avmMap = useSelector<RootState, CurrentAVMMap>(selectCurrentAVMMap)
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const addressId = searchParams.get('id')
  if (!addressId) {
    Sentry.captureMessage(
      'Failed to parse address id (fips and apn) from URL in Homeowner Preview'
    )
    return null
  }
  const avm = avmMap[addressId]
  const amount = avm?.amount

  return (
    <NetWorthSection
      withCurrentHomeData={false}
      homeValue={amount}
      hasLoans={false}
      outstandingPrincipal={0}
      estimatedValue={amount}
    />
  )
}
